<template>
    <div>
        <div class="d-flex justify-end mb-2" v-if="['company-list', 'company-edit'].includes($route.name)">
            <v-btn
                color="primary"
                :to="{ name: 'company-edit', params: {id: 'new'} }"
                class="ma-2">Add +
            </v-btn>
        </div>
        <CompaniesEditModal v-if="$route.name === 'company-edit'"/>
    </div>
</template>

<script>
import CompaniesEditModal from './CompaniesEditModal.vue';

export default {
    name: 'CompaniesEdit',
    components: {CompaniesEditModal},
    data() {
        return {
            modal: true,
        };
    },
};
</script>

<style scoped>

</style>